<template>
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :modal-append-to-body="false"
        class="staff-index-dialog"
        left>
        <!-- form -->
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-width="86px"
            label-position="right"
            label-suffix=":"
            v-if="form"
            @submit.native.prevent>
            <div class="flex">
                <div style="width: 80%;" class="flex flex-wrap">
                    <el-form-item prop="jobNum" :label="$t('Staff.job_number')" >
                        <el-input
                            v-model="form.jobNum"
                            :placeholder="$t('Staff.job_number_placeholder')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="nickname" :label="$t('Staff.nickname')">
                        <el-input
                            v-model="form.nickname"
                            :placeholder="$t('Fill.nickname')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="account" :label="$t('Staff.login_count')" >
                        <el-input
                            :disabled="form.isSuperAdmin"
                            v-model="form.account"
                            :placeholder="$t('Fill.login_count')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Staff.password')" >
                        <el-input
                            :disabled="form.isSuperAdmin"
                            v-model="form.password"
                            :placeholder="form.id ? $t('Fill.no_password') : $t('Fill.password')"
                            type="password">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Staff.actual_name')" prop="name">
                        <el-input
                            v-model="form.name"
                            :placeholder="$t('Fill.actual_name')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Common.gender')" prop="genderCode">
                        <el-radio-group v-model="form.genderCode">
                            <el-radio :label="1">{{ $t('Common.male') }}</el-radio>
                            <el-radio :label="2">{{ $t('Common.female') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="storeRangeCode" :label="$t('Staff.store_range')">
                        <el-radio-group
                            :disabled="form.isSuperAdmin"
                            @change="selectRangCode"
                            v-model="form.storeRangeCode">
                            <el-radio :label="0">{{ $t('Staff.single_store') }}</el-radio>
                            <el-radio :label="1">{{ $t('Staff.national') }}</el-radio>
                            <el-radio :label="2">{{ $t('Reception.Fourth.area1') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        style="width: 90%;"
                        prop="storeIds"
                        :label="$t('Common.store')"
                        v-if="form.storeRangeCode === 0">
                        <div v-if="form.storeRangeCode === 0" class="box-1e">
                            <div>
                                <el-checkbox
                                        :indeterminate="isIndeterminate"
                                        v-model="checkAllStore"
                                        @change="handleCheckAllStoreChange">{{ $t('Course.check_all') }}</el-checkbox>
                                <div class="box-a checkbox-warp">
                                    <el-checkbox-group v-model="form.storeIds" @change="handleCheckedStoresChange">
                                        <el-checkbox
                                                v-for="item in stores"
                                                :label="item.id"
                                                :key="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="请选择区域" v-if="form.storeRangeCode === 2">
                        <el-select
                            v-model="form.provinceId"
                            placeholder="请选择省份"
                            class="w-1/5"
                            @change="handleProvinceChange"
                        >
                            <el-option
                            v-for="item in this.district"
                            :key="item.id"
                            :value="item.id"
                            :label="item.fullname"
                            />
                        </el-select>
                        <el-select
                            v-model="form.cityId"
                            placeholder="请选择城市"
                            class="w-1/5"
                            @change="handleCityChange"
                        >
                            <el-option
                            v-for="item in this.province.children"
                            :key="item.id"
                            :value="item.id"
                            :label="item.fullname"
                            />
                        </el-select>
                        <el-select v-model="form.districtId" placeholder="请选择地区" class="w-1/5">
                            <el-option
                                v-for="item in this.city.children"
                                :key="item.id"
                                :value="item.id"
                                :label="item.fullname"
                            />
                        </el-select>
                    </el-form-item>
                    <div style="width: 100%;"></div>
                    <el-form-item :label="$t('Common.phone_phone')" prop="phone">
                        <el-input
                            v-enter-number2
                            :disabled="form.isSuperAdmin"
                            v-model="form.phone"
                            placeholder="请输入手机号"
                            maxlength="11">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Common.birthday')">
                        <el-date-picker
                            v-model="form.birthday"
                            type="date"
                            style="width:180px"
                            :placeholder="$t('Reception.Third.time_placeholder')"
                            value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <el-form-item :label="$t('Common.wechat')">
                        <el-input v-model="form.wechat" :placeholder="$t('Common.wechat_placeholder')"></el-input>
                    </el-form-item>
                    <el-form-item label="Email">
                        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Staff.synopsis')" style="width: 90%;">
                        <el-input type="textarea" :rows="6" v-model="form.description" placeholder="请输入简介"></el-input>
                    </el-form-item>
                    <div style="width: 100%;"></div>
                    <el-form-item :label="$t('Staff.Employee_photo')" >
                        <file-upload v-if="form.albums.length < 9"
                            ref="upload" @input="addImg(arguments)">
                            <div class="iconfont icon-fitness-jiahao lessons-image"></div>
                        </file-upload>
                        <!-- 图片显示 -->
                        <div
                            v-for="(item, index) in form.albums"
                            :key="index"
                            class="add-lessons-pic"
                            :style="`background-image: url(${item});`">
                            <div class="iconfont icon-fitness-jianshanchu-yuankuang add-lessons-delete"
                                @click="deleteImg(index)"></div>
                        </div>
                        <div class="staff-albums-text">上传图片建议比例16：9，最多8张</div>
                    </el-form-item>
                </div>
                <div class="form-avatar-upload">
                    <file-upload v-model="form.avatar" :ratio="1/1">
                        <div class="avator-bg flex items-center justify-center">
                            <div v-if="!form.avatar" class="iconfont icon-fitness-touxiang2"></div>
                            <div v-if="form.avatar"
                                class="avatar"
                                :style="`background-image: url(${form.avatar})`">
                            </div>
                        </div>
                    </file-upload>
                    <p style="margin-left:12px;margin-top:-5px;">选择头像</p>
                </div>
            </div>
            <el-form-item class="staff-show-coach" :label="$t('Staff.Show_style_coach')">
                <el-radio
                    v-for="(item, index) in showOptions"
                    :key="index"
                    v-model="form.showOnApp"
                    :label="item.value"
                >{{ item.label }}</el-radio>
            </el-form-item>
            <div style="border-top:1px solid #e6e6e6;" class="mb-10"></div>
            <div class="flex flex-wrap staff-form-three">
                <el-form-item prop="jobStatusCode" :label="$t('Staff.Incumbency')">
                    <el-select
                        style="width:160px"
                        v-model="form.jobStatusCode"
                        :placeholder="$t('Staff.Incumbency')">
                        <el-option :label="$t('Staff.be_on_the_job')" :value="1"/>
                        <el-option :label="$t('Staff.practice')" :value="2"/>
                        <el-option :label="$t('Staff.part-timejob')" :value="3"/>
                        <el-option :label="$t('Staff.dimission')" :value="4"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Staff.entry_time')">
                    <el-date-picker
                        style="width: 160px;"
                        v-model="form.workedAt"
                        type="date"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item :label="$t('Staff.resignation_time')">
                    <el-date-picker
                        v-model="form.leftAt"
                        type="date"
                        style="width:160px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item prop="levelCode" label="员工等级">
                    <el-select v-model="form.levelCode" class="w-full" clearable>
                        <el-option label="1级" :value="1"/>
                        <el-option label="2级" :value="2"/>
                        <el-option label="3级" :value="3"/>
                        <el-option label="4级" :value="4"/>
                        <el-option label="5级" :value="5"/>
                    </el-select>
                </el-form-item>
                <el-form-item prop="bankAccount" :label="$t('Staff.Bank_card_number')">
                    <el-input v-model="form.bankAccount" placeholder="请输入银行卡号"></el-input>
                </el-form-item>
                <el-form-item prop="bankName" :label="$t('Staff.opening_bank')">
                    <el-input v-model="form.bankName" placeholder="请填写开户银行"></el-input>
                </el-form-item>
            </div>
            <div style="border-top:1px solid #e6e6e6;" class="mb-10"></div>
            <div class="flex">
                <el-form-item prop="idNum" :label="$t('Sell.identity_number')">
                    <el-input
                        v-model="form.idNum"
                        :placeholder="$t('Fill.identity_number_placeholder')">
                    </el-input>
                </el-form-item>
                <el-form-item prop="address" :label="$t('Staff.current_residence')">
                    <el-input
                        v-model="form.address"
                        placeholder="请输入现居住地"
                        style="width: 385px;">
                    </el-input>
                </el-form-item>
            </div>
            <div class="flex flex-wrap staff-form-three">
                <el-form-item prop="school" :label="$t('Staff.school_graduation')">
                    <el-input v-model="form.school" placeholder="请输入毕业学校"></el-input>
                </el-form-item>
                <el-form-item prop="major" :label="$t('Staff.major')">
                    <el-input v-model="form.major" placeholder="请输入专业"></el-input>
                </el-form-item>
                <el-form-item prop="graduatedAt" :label="$t('Staff.GraduationDate')">
                    <el-date-picker
                        v-model="form.graduatedAt"
                        type="date"
                        style="width:160px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item prop="educationCode" label="学历">
                    <el-select
                        v-model="form.educationCode"
                        placeholder="请选择学历"
                        class="col-12">
                        <el-option label="未填" :value="0"/>
                        <el-option label="专科" :value="1"/>
                        <el-option label="本科" :value="2"/>
                        <el-option label="研究生" :value="3"/>
                        <el-option :label="$t('Sell.Pay.other')" :value="4"/>
                    </el-select>
                </el-form-item>
                <el-form-item prop="birthplace" :label="$t('Staff.nativeplace')">
                    <el-input
                        v-model="form.birthplace"
                        placeholder="请输入籍贯">
                    </el-input>
                </el-form-item>
                <el-form-item prop="nationCode" :label="$t('Client.Add.nation')">
                    <el-select
                        v-model="form.nationCode"
                        placeholder="请选择民族"
                        class="col-12">
                        <el-option label="未填" :value="0"/>
                        <el-option label="汉族" :value="1"/>
                        <el-option label="壮族" :value="2"/>
                        <el-option label="满族" :value="3"/>
                        <el-option label="回族" :value="4"/>
                        <el-option label="苗族" :value="5"/>
                        <el-option label="维吾尔族" :value="6"/>
                        <el-option label="土家族" :value="7"/>
                        <el-option label="彝族" :value="8"/>
                        <el-option label="蒙古族" :value="9"/>
                        <el-option label="藏族" :value="10"/>
                        <el-option :label="$t('Sell.Pay.other')" :value="11"/>
                    </el-select>
                </el-form-item>
                <el-form-item prop="marriageCode" label="婚姻状况">
                    <el-select
                        v-model="form.marriageCode"
                        placeholder="请选择婚姻状况"
                        class="col-12">
                        <el-option label="未填" :value="0"/>
                        <el-option label="已婚" :value="1"/>
                        <el-option label="未婚" :value="2"/>
                    </el-select>
                </el-form-item>
                <el-form-item prop="childrenCode" label="子女情况">
                    <el-select
                        v-model="form.childrenCode"
                        placeholder="请选择子女情况"
                        class="col-12">
                        <el-option label="未填" :value="0"/>
                        <el-option label="有子女" :value="1"/>
                        <el-option label="无子女" :value="2"/>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item prop="roleIds" :label="$t('Staff.role')">
                <div style="border:1px solid #ccc;padding: 0 10px;margin: 0px; width:100%">
                    <div class="box-a checkbox-warp" style="width:100%">
                        <el-checkbox-group v-model="roleIdCopy">
                            <el-checkbox
                                v-for="item in roles"
                                :label="item.id"
                                :key="item.id"
                                style="max-height: 130px!important; width: 22%"
                            >{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </el-form-item>
            <el-form-item prop="remark" :label="$t('Common.remark')">
                <el-input v-model="form.remark" placeholder="请输入备注" type="textarea" :rows="3"/>
            </el-form-item>
        </el-form>
        <!-- button -->
        <span slot="footer" class="dialog-footer" v-if="!readonly">
            <el-button @click="close">{{ $t('Common.close') }}</el-button>
            <el-button type="primary" @click="onSubmit">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio, DatePicker, RadioGroup, Row, Col } from 'element-ui';
import FileUpload from '../base/FileUpload';

export default {
    components: {
        FileUpload,
        ElDialog: Dialog,
        ElRadio: Radio,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRow: Row,
        ElCol: Col,
    },
    data() {
        return {
            checkAllStore: false,
            isIndeterminate: false,
            visible: false,
            loading: false,
            stores: [],
            roles: [],
            roleIds: [],
            storesIdCpoy: [],
            roleIdCopy: [],
            city: [],
            area: [],
            district: [],
            province: '',
            form: {
                id: '',
                jobNum: '',
                avatar: '',
                nickname: '',
                account: '',
                password: '',
                name: '',
                genderCode: '',
                phone: '',
                birthday: null,
                wechat: '',
                email: '',
                description: '',
                albums: [],
                storeRangeCode: 0,
                regionIds: [],
                storeIds: [],
                jobStatusCode: '',
                workedAt: null,
                leftAt: null,
                levelCode: '',
                bankAccount: '',
                bankName: '',
                idNum: '',
                address: '',
                school: '',
                major: '',
                graduatedAt: null,
                educationCode: '',
                birthplace: '',
                nationCode: '',
                marriageCode: '',
                roleIds: [],
                remark: '',
                showOnApp: 0,
            },
            rules: {
                account: { required: true, message: '请输入账户', trigger: 'blur' },
                password: { required: true, message: this.$t('Other.login.Password'), trigger: 'blur' },
                nickname: { required: true, message: '请输入昵称', trigger: 'blur' },
                name: { required: true, message: '请输入真实姓名', trigger: 'blur' },
                genderCode: { required: true, message: '请选择性别', trigger: 'blur' },
                phone: { required: true, message: '请输入手机号', trigger: 'blur' },
                jobNum: { required: true, message: '请输入工号', trigger: 'blur' },
                storeRangeCode: {
                    required: true,
                    message: '门店范围不能为空',
                    trigger: 'blur',
                },
            },
            title: '编辑员工',
            showOptions: [
                {
                    value: 1,
                    label: this.$t('Common.yes'),
                }, {
                    value: 0,
                    label: this.$t('Common.no'),
                },
            ],
        };
    },
    watch: {},
    computed: {},
    methods: {
        addImg(args) {
            this.form.albums.push(args[0]);
        },
        deleteImg(index) {
            this.form.albums.splice(index, 1);
        },
        createData() {
            this.form = {
                jobNum: '',
                avatar: '',
                nickname: '',
                account: '',
                password: '',
                name: '',
                genderCode: '',
                phone: '',
                birthday: '',
                wechat: '',
                email: '',
                description: '',
                albums: [],
                storeRangeCode: '',
                regionIds: [],
                storeIds: [],
                /* storeRangeCode: '', */
                jobStatusCode: '',
                workedAt: null,
                leftAt: '',
                levelCode: '',
                bankAccount: '',
                bankName: '',
                idNum: '',
                address: '',
                school: '',
                major: '',
                graduatedAt: null,
                educationCode: '',
                birthplace: '',
                nationCode: '',
                marriageCode: '',
                roleIds: [],
                remark: '',
                storesIdCpoy: [],
                roleIdCopy: [],
                showOnApp: 0,
            };
            this.readonly = false;
            this.roleIdCopy = [];
        },
        open(data) {
            if (data) {
                this.fetchData(data.id);
                this.title = '编辑员工';
            } else {
                this.createData();
                this.title = '新建员工';
            }
            this.fetchRole();
            this.fetchStore();
            this.visible = true;
        },
        selectRangCode() {
            if (this.form.storeRangeCode === 2) this.fetchDistrict();
        },
        close() {
            this.visible = false;
        },
        fetchData(id) {
            this.loading = true;
            API.get(`staff/${id}`).then(res => {
                res.showOnApp = res.showOnApp ? 1 : 0;
                res.password = '******';
                this.form = res;
                if (res.roleIds) this.roleIdCopy = res.roleIds;
                if (res.storeIds) this.storesIdCpoy = res.storeIds;
                if (this.form.storeRangeCode === 2) this.fetchDistrict();
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchRole() {
            this.loading = true;
            API.get('role/list').then(res => {
                this.roles = res;
            }).finally(() => {
                this.loading = false;
            }).catch(err => {
                $ele.$message.error(err);
            });
        },
        fetchStore() {
            this.loading = true;
            API.get('store/list').then(res => {
                this.stores = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        async postData() {
            let form = Object.assign({}, this.form);
            if (form.password === '******') form.password = '';
            form.roleIds = this.roleIdCopy;
            if (form.storeRangeCode === 2) {
                let array = [];
                array[0] = form.provinceId;
                array[1] = form.cityId;
                array[2] = form.districtId;
                form.regionIds = array;
            }
            form.showOnApp = this.form.showOnApp ? true : false;
            let request;
            if (form.id) request = API.put(`staff/${form.id}`, form);
            else request = API.post('staff', form);
            request.then(() => {
                $ele.$message.success(this.$t('Message.save'));
                this.createData();
                if (form.id) this.$emit('fetchStaff');
                else this.$emit('fetchStaff', 1);
                this.close();
            }).catch(() => {}).finally(() => {});
        },
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.postData();
                } else {
                    $ele.$message('请输入完整信息！');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.form.resetFields();
        },
        // 省
        fetchDistrict() {
            this.loading = true;
            API.get('district').then(res => {
                this.district = res;
                if (this.form.id && this.form.regionIds.length) {
                    this.$set(this.form, 'provinceId', this.form.regionIds[0]);
                }
                if (this.form.provinceId) {
                    this.handleProvinceChange(this.form.provinceId);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 市
        handleProvinceChange(val) {
            this.$set(this.form, 'cityId', null);
            this.$set(this.form, 'districtId', null);
            if (this.district) {
                this.district.forEach(el => {
                    if (el.id === val) {
                        this.province = el;
                    }
                    return el;
                });
                if (this.form.id && this.form.regionIds.length) {
                    this.$set(this.form, 'cityId', this.form.regionIds[1]);
                }
            }
            this.handleCityChange(this.form.cityId);
        },
        // 区
        handleCityChange(val) {
            this.$set(this.form, 'districtId', null);
            if (this.province && this.province.children) {
                this.province.children.forEach(el => {
                    if (el.id === val) {
                        this.city = el;
                    }
                });
                if (this.form.id && this.form.regionIds.length) {
                    this.$set(this.form, 'districtId', this.form.regionIds[2]);
                }
            }
            if (this.form.regionIds && this.form.regionIds.length) this.form.regionIds = [];
        },
        handleCheckAllStoreChange(val) {
            this.form.storeIds = val ? this.stores.map(el => el.id) : [];
            this.isIndeterminate = false;
        },
        handleCheckedStoresChange(value) {
            const checkedCount = value.length;
            this.checkAllStore = checkedCount === this.stores.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
    },
    upload() {
        API.post();
    },
    created() {
        this.createData();
        this.fetchRole();
        this.fetchStore();
    },
};
</script>
<style lang="scss">
.staff-index-dialog {
    .el-dialog {
        width: 800px;
        max-height: 800px;
    }
    .el-dialog__body {
        max-height: 680px;
        overflow-y: auto;
    }
    .box-a {
        padding: 10px 15px;
        background: #fff!important;
        min-height: 70px!important;
        overflow: scroll;
        max-height: 130px!important;
    }
    .box-1e {
        position: relative;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 100%;
        min-height: 200px;
    }
    .card-check-store {
        margin-top: 15px;
        border: 1px solid #e6e6e6;
        padding: 10px;
        max-height: 90px;
        overflow-y: auto;
    }
    .el-form-item__label {
        font-size: 13px;
    }
    .el-input {
        width: 180px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 65px 0 25px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .checkbox-wrap {
        min-height: 32px;
        padding-top: 0;
        margin-bottom: 15px;
        overflow: hidden;
    }
    .avator-bg {
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background: #697a8e;
        color: #fff;
        margin-bottom: 10px;

        .iconfont {
            font-size: 50px;
        }

        .avatar {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-size: cover;
            background-position: center;
        }
    }
    .lessons-image {
        width: 100px;
        height: 60px;
        border: 1px solid #e6e6e6;
        position: relative;
        margin-right: 10px;
        border-radius: 3px;

        &:hover {
            background: #05abef;
        }

        &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 50px;
            color: #f2f2f2;

            &:hover {
                color: #fff;
            }
        }
    }
    .add-lessons-pic {
        width: 100px;
        height: 60px;
        background-size: cover;
        background-position: center;
        display: inline-block;
        margin-right: 10px;
        position: relative;

        &:last-child {
            margin-right: 0;
        }
    }
    .add-lessons-delete {
        position: absolute;
        right: -6px;
        top: -15px;
        color: red;
    }
    .staff-albums-text {
        font-size: 12px;
        color: #4c4c4c;
    }
}
.staff-form-three {
    .el-input {
        width: 160px !important;
    }
}
.staff-show-coach {
    .el-form-item__label {
        width: 160px !important;
    }
}
</style>
